import request from './request'

/**
 * 员工登录
 */
export const login = (data) => {
  return request.post('/auth/login', data)
}

/**
 * 获取当前用户信息
 */
export const getUserInfo = () => {
  return request.get('/auth/userinfo')
}

/**
 * 退出登录
 */
export const logout = () => {
  return request.post('/auth/logout')
}

/**
 * 获取图片验证码
 */
export const getCaptcha = () => {
  return request.get('/auth/captcha')
}
